module.exports = __webpack_public_path__ + "img/planetary-rev04.5d932033.jpg";